import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export const PreferencesSlice = createSlice({
  name: 'preferences',
  initialState: {
    show: false,
    activeSection: null as string | null,
  },
  reducers: {
    setShowPreferences: (state, { payload: show }: PayloadAction<boolean>) => {
      console.log('Toggle show: ', show);
      state.show = show;
    },
    setPreferencesActiveSection: (
      state,
      { payload }: PayloadAction<string | null>,
    ) => {
      state.activeSection = payload;
    },
  },
});

export const selectShowPreferences = (state: {
  preferences: { show: boolean };
}) => state.preferences.show;

export const selectPreferencesActiveSection = (state: {
  preferences: { activeSection: string | null };
}) => state.preferences.activeSection;

export const { setShowPreferences, setPreferencesActiveSection } =
  PreferencesSlice.actions;

export default PreferencesSlice.reducer;
